export enum PartnerPlacement {
	'Partner Placement' = 0,
	Left = 1,
	Right = 2,
}
